export default __webpack_public_path__ + "static/media/matrixscreenshot.17bbdea9.png";